import { LocationLandingLayout, LocationPageContent } from './LocationLandingLayout'

const content: LocationPageContent = {
  locale: 'tr',
  slug: 'istanbul-performans-pazarlama-ajansi',
  meta: {
    title: 'İstanbul Performans Pazarlama Ajansı | Thinklyze',
    description:
      'İstanbul\'da ölçülebilir sonuçlar sunan performans pazarlama ajansı. Google Ads, Meta Ads ve programatik reklamlarla ROAS\'ınızı artırın.',
    keywords: [
      'İstanbul performans pazarlama ajansı',
      'İstanbul performance marketing',
      'İstanbul Google Ads ajansı',
      'İstanbul reklam ajansı',
      'performans pazarlama istanbul',
      'ROAS optimizasyon istanbul',
      'dijital reklam ajansı istanbul',
    ],
    canonical: 'https://thinklyze.com/istanbul-performans-pazarlama-ajansi',
  },
  hero: {
    badge: 'İstanbul Performans Pazarlama',
    title: 'Her Lira Harcamanızın Karşılığını Alan Performans Pazarlama Ajansı',
    subtitle:
      'İstanbul\'da faaliyet gösteren işletmeler için Google Ads, Meta Ads ve programatik reklam kanallarında ölçülebilir büyüme. Bütçenizi boşa harcamayın; her tıklamayı gelire dönüştürün.',
    stats: [
      { value: '%340', label: 'Ortalama ROAS Artışı' },
      { value: '%60', label: 'CPA Düşüşü' },
      { value: '150+', label: 'Aktif Kampanya' },
    ],
    highlights: [
      {
        title: 'ROAS Odaklı Kampanyalar',
        description:
          'Her kampanyayı gelir hedefiyle kuruyor, günlük optimizasyonla bütçe getirisini maksimize ediyoruz.',
      },
      {
        title: 'Çoklu Kanal Yönetimi',
        description:
          'Google, Meta, TikTok ve programatik kanalları tek strateji çatısı altında koordineli şekilde yönetiyoruz.',
      },
      {
        title: 'Anlık Dashboard Erişimi',
        description:
          'Tüm reklam harcamalarınızı ve dönüşümlerinizi gerçek zamanlı Looker Studio panelinden takip ediyorsunuz.',
      },
    ],
  },
  problemSolution: {
    title: 'Performans Reklamcılığında Sık Yapılan Hatalar',
    subtitle:
      'İstanbul\'daki çoğu işletme aynı hatalarla bütçe israf ediyor. Biz bu hataları daha başlamadan engelliyoruz.',
    items: [
      {
        title: 'Geniş Hedefleme = Düşük Kaliteli Trafik',
        description:
          'Doğru kitleye doğru mesajla ulaşmayan reklamlar tıklama üretir ama satış getirmez. Hassas audience segmentasyonuyla yalnızca potansiyel alıcılara ulaşıyoruz.',
      },
      {
        title: 'Takip Kurulmadan Reklam Vermek',
        description:
          'Conversion tracking olmadan hangi kampanyanın işe yaradığını bilemezsiniz. GA4, Enhanced Conversions ve server-side tracking kurulumunu eksiksiz yapıyoruz.',
      },
      {
        title: 'Tek Kanal Bağımlılığı',
        description:
          'Sadece Google veya sadece Meta kullanmak büyük fırsatları kaçırır. Müşteri yolculuğunun her aşamasında farklı kanallarla temas kuruyoruz.',
      },
      {
        title: 'Landing Page Optimizasyonu Yok',
        description:
          'En iyi reklam bile kötü bir landing page ile boşa gider. CRO ve A/B testleriyle açılış sayfalarınızın dönüşüm oranını sürekli artırıyoruz.',
      },
    ],
  },
  services: {
    title: 'Performans Pazarlama Hizmetleri',
    subtitle: 'İstanbul işletmeleri için sonuç odaklı reklam çözümleri.',
    items: [
      {
        title: 'Google Search & Shopping Ads',
        description:
          'Yüksek niyetli aramalarda rakiplerinizin önünde görünün; e-ticaret için Shopping kampanyalarıyla ürün bazlı satış artırın.',
      },
      {
        title: 'Meta Ads (Facebook & Instagram)',
        description:
          'Prospecting, retargeting ve Advantage+ kampanyalarıyla İstanbul\'daki hedef kitlenizi huninin her aşamasında yakalayın.',
      },
      {
        title: 'TikTok Reklam Yönetimi',
        description:
          'Gen Z ve millennial kitlesine video içerikli reklamlarla ulaşın; organik görünümlü reklamlarla düşük CPA elde edin.',
      },
      {
        title: 'Programatik Reklam',
        description:
          'Display, video ve native formatlarında geniş çaplı marka bilinirliği kampanyaları; gerçek zamanlı teklif optimizasyonu.',
      },
      {
        title: 'Yeniden Hedefleme (Retargeting)',
        description:
          'Sitenizi ziyaret edip alışveriş yapmayan kullanıcıları dinamik ürün reklamlarıyla geri kazanın.',
      },
      {
        title: 'Dönüşüm Oranı Optimizasyonu (CRO)',
        description:
          'Isı haritaları, oturum kayıtları ve A/B testleriyle reklam trafiğinizi daha fazla gelire dönüştürün.',
      },
    ],
  },
  locationBenefits: {
    title: 'İstanbul\'da Performans Pazarlama Ajansı Seçmenin Avantajları',
    items: [
      {
        title: 'Yerel Rakip Analizi',
        description:
          'İstanbul\'daki doğrudan rakiplerinizi izliyor, boşluklardan yararlanacak kampanya stratejileri geliştiriyoruz.',
      },
      {
        title: 'Türk Tüketicisi için Optimize Metinler',
        description:
          'Yerel dil, kültür ve alışveriş alışkanlıklarını bilen copywriter ekibimizle daha yüksek tıklama oranları elde edin.',
      },
      {
        title: 'Hızlı Bütçe Esnekliği',
        description:
          'Kampanya bütçesini anlık satış verilerine göre anında revize edebiliyor, fırsatları kaçırmıyoruz.',
      },
      {
        title: 'Sektöre Özel Deneyim',
        description:
          'E-ticaret, moda, sağlık ve emlak gibi İstanbul\'da rekabetçi sektörlerde kanıtlanmış sonuçlarımız var.',
      },
      {
        title: 'Yüz Yüze Strateji Toplantıları',
        description:
          'Gerektiğinde yüz yüze buluşuyor, kampanya değişikliklerini süratle hayata geçiriyoruz.',
      },
      {
        title: 'Tüm Platform Sertifikasyonları',
        description:
          'Google Partner ve Meta Business Partner sertifikalarına sahip uzman ekibimizle çalışıyorsunuz.',
      },
    ],
  },
  process: {
    title: 'Performans Pazarlama Sürecimiz',
    items: [
      { title: 'Hesap Denetimi', description: 'Mevcut reklam hesaplarınızı inceliyor, kayıp alanları ve fırsatları tespit ediyoruz.' },
      { title: 'Strateji Geliştirme', description: 'Kanal, bütçe ve hedef kitle planını 30 günlük sprintler halinde oluşturuyoruz.' },
      { title: 'Kampanya Kurulumu', description: 'Takip sistemleri, audience\'lar ve yaratıcı materyaller eksiksiz hazırlanıyor.' },
      { title: 'Optimizasyon & Ölçeklendirme', description: 'A/B testleri ve günlük bid yönetimiyle ROAS\'ı artırıp ölçeklendiriyoruz.' },
    ],
  },
  faqs: [
    {
      question: 'Performans pazarlama ile marka pazarlamanın farkı nedir?',
      answer:
        'Performans pazarlama her harcamanın ölçülebilir bir aksiyona (tıklama, lead, satış) bağlandığı modeldir. Marka pazarlama uzun vadeli bilinirlik hedefler; performans pazarlama kısa vadeli gelir üretir. En iyi sonuç ikisini birlikte kullanmakla elde edilir.',
    },
    {
      question: 'Aylık reklam bütçem ne kadar olmalı?',
      answer:
        'Bu; sektörünüze, rekabete ve hedeflerinize göre değişir. Ücretsiz keşif görüşmesinde sektörünüze özel benchmark verileriyle minimum efektif bütçeyi birlikte hesaplıyoruz.',
    },
    {
      question: 'Kampanya sonuçlarını nasıl takip edebilirim?',
      answer:
        'Size özel Looker Studio paneli üzerinden 7/24 gerçek zamanlı verilere erişebilirsiniz. Haftalık güncelleme e-postaları ve aylık detaylı raporlar da sunuyoruz.',
    },
    {
      question: 'Hangi sektörlerde performans pazarlama yapıyorsunuz?',
      answer:
        'E-ticaret, perakende, sağlık, güzellik, emlak, eğitim, finans ve SaaS gibi geniş bir sektör yelpazesinde İstanbul işletmelerine hizmet veriyoruz.',
    },
  ],
  cta: {
    badge: 'Ücretsiz Reklam Hesap Analizi',
    title: 'Reklam Bütçenizin Kaçını Boşa Harcıyorsunuz?',
    description:
      'Mevcut Google veya Meta hesabınızı ücretsiz analiz ediyoruz. Kayıp alanları, iyileştirme fırsatlarını ve tahmini ROAS artışını somut verilerle sunuyoruz.',
  },
  areaServed: ['İstanbul', 'Bakırköy', 'Şişli', 'Kadıköy', 'Beşiktaş', 'Ataşehir', 'Ümraniye'],
  coordinates: { latitude: 41.0082, longitude: 28.9784 },
  address: {
    streetAddress: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
    addressLocality: 'Bakırköy',
    addressRegion: 'İstanbul',
    postalCode: '34140',
    addressCountry: 'TR',
  },
  relatedServices: {
    title: 'İlgili Hizmetlerimiz',
    items: [
      { name: 'Google Ads Yönetimi', href: '/services/google-ads', description: 'Arama, Shopping ve YouTube kampanyaları.' },
      { name: 'Meta Ads Yönetimi', href: '/services/meta-ads', description: 'Facebook ve Instagram performans reklamları.' },
      { name: 'SEO & GEO', href: '/services/seo-geo', description: 'Organik büyüme ve yerel arama optimizasyonu.' },
      { name: 'Pazaryeri Yönetimi', href: '/services/marketplace', description: 'Trendyol ve Hepsiburada reklam optimizasyonu.' },
    ],
  },
}

const IstanbulPerformanceMarketingAgency = () => {
  return <LocationLandingLayout content={content} />
}

export default IstanbulPerformanceMarketingAgency
